import React from 'react';
import _ from 'lodash';

import { formatDate } from 'src/utils/Date';
import { getOptionLabel, display } from 'src/utils/Utils';
import { useTranslation } from 'react-i18next';

const EmployeeLeaveOfAbsenceItemShow = ({ employeeLeaveOfAbsences, leaveOfAbsenceReasonTypes }) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      {_.map(employeeLeaveOfAbsences, (item, index) => (
        <tr key={item.id}>
          <th>{index === 0 ?  t('features.Employees.components.EmployeeLeaveOfAbsenceItemShow.leave_of_absence_period'): ''}</th>
          <td>
            <div>
              {formatDate(item.startOn)}〜{formatDate(item.endOn)}
            </div>
            <div>{display(getOptionLabel(item.reasonType)(leaveOfAbsenceReasonTypes))}</div>
          </td>
        </tr>
      ))}
    </React.Fragment>
  );
};

export default EmployeeLeaveOfAbsenceItemShow;
